var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"result-text theme-title transparent appbar-result-action",attrs:{"tile":"","flat":""}},[_vm._v(" "+_vm._s(this.team_a_set_score)+" "),_c('span',{staticClass:"score-spacer ml-1 mr-1 theme-title"},[_vm._v(" - ")]),_vm._v(" "+_vm._s(this.team_b_set_score)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }